import React, { useState, useMemo, useEffect } from 'react';
import { Container, Row, Col, Image, Tabs, Tab } from 'react-bootstrap';
import { useUserContext } from '../UserContext';
import { useEntidadeContext } from '../EntidadeContext';
import logoImage from '../img/logo.png';
import RelatorioPacotesTab from '../components/relatorios/RelatorioPacotesTab';

const RelatoriosPage = () => {
    const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig } = useUserContext(); // Obter do contexto

    // Obter abas permitidas para a página de Relatórios
    const permittedTabs = useMemo(() => {
        return getPermittedInternalTabs('relatorios', currentUserRole);
    }, [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig]);

    const [activeTabKey, setActiveTabKey] = useState('');

    // Define a aba ativa inicial para a primeira aba permitida
    useEffect(() => {
        if (permittedTabs.length > 0 && !activeTabKey) {
            setActiveTabKey(permittedTabs[0].key);
        }
    }, [permittedTabs, activeTabKey]);

    return (
        <div style={{ border: '1px solid gray', backgroundColor: '#f5f5f5' }}>
            <div className="header" style={{ minHeight: '80px' }}>
                <Row className="p-1 align-items-center" style={{ minHeight: 'inherit' }}>
                    <Col xs={12} md={6} style={{ minHeight: '60px' }}>
                        <div className="d-flex align-items-center justify-content-start h-100">
                            <Image src={logoImage} alt="Logo Clínica" style={{ maxHeight: '60px', marginLeft: '12px' }} />
                            <h3 style={{ marginLeft: '15px', marginBottom: '0' }}>Relatórios Gerenciais</h3>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="body p-3">
                <Tabs activeKey={activeTabKey} onSelect={(k) => setActiveTabKey(k)} className="mb-3">
                    {/* Renderiza as abas dinamicamente com base nas permissões */}
                    {permittedTabs.map(tabInfo => {
                        let tabContent = null;
                        // Verifica se a chave da aba é a de pacotes de serviços
                        if (tabInfo.key === 'rel_pacote_servicos') {
                            tabContent = <RelatorioPacotesTab isActive={activeTabKey === tabInfo.key} />;
                        }
                        // Adicione mais 'else if' para outras abas de relatório no futuro
                        return (
                            <Tab key={tabInfo.key} eventKey={tabInfo.key} title={tabInfo.title}>
                                {tabContent}
                            </Tab>
                        );
                    })}
                </Tabs>
            </div>
        </div>
    );
};

export default RelatoriosPage;